import { deletePending,deleteSuccess,deleteFail } from "./userDeleteSlice";
import { userDelete } from "../../../api/userApi";
export const newUserDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deletePending());
        const result = await userDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteSuccess(result.message))
        : dispatch(deleteFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
        const err= JSON.parse(JSON.stringify(error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteFail(error.message));
    }
    
}

